module.exports = __webpack_public_path__ + "static/media/93gal14.2bb6a7fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/93gal/93gal14.jpg
// module id = 308
// module chunks = 0